export const PAYMENT_PLAN_SELECTED = 'PAYMENT_PLAN_SELECTED'
export const PAYMENT_PLAN_SELECTED_FROM_PLANS =
  'PAYMENT_PLAN_SELECTED_FROM_PLANS'
export const PAYMENT_PLAN_UPDATED = 'PAYMENT_PLAN_UPDATED'
export const PAYMENT_REQUESTED = 'PAYMENT_REQUESTED'
export const PAYMENT_RECEIVED = 'PAYMENT_RECEIVED'
export const COUPON_FETCHED = 'COUPON_FETCHED'
export const COUPON_LOADED = 'COUPON_LOADED'
export const COUPON_CAHNGED = 'COUPON_CAHNGED'
export const IS_COUPON_VALID_REQUESTED = 'IS_COUPON_VALID_REQUESTED'
export const IS_COUPON_VALID_RECEIVED = 'IS_COUPON_VALID_RECEIVED'
export const PROCEED_TO_CHECKOUT_PRESSED_CANCELLED =
  'PROCEED_TO_CHECKOUT_PRESSED_CANCELLED'
export const COUPON_VALID_PARTIAL = 'COUPON_VALID_PARTIAL'
export const COUPON_VALID_FULL = 'COUPON_VALID_FULL'
export const CHECKOUT_SESSION_REQUESTED = 'CHECKOUT_SESSION_REQUESTED'
export const CHECKOUT_SESSION_REQUESTED_FAILURE =
  'CHECKOUT_SESSION_REQUESTED_FAILURE'
export const CHECKOUT_SESSION_NO_MEMBER_REQUESTED =
  'CHECKOUT_SESSION_NO_MEMBER_REQUESTED'
export const CHECKOUT_SESSION_RECEIVED = 'CHECKOUT_SESSION_RECEIVED'
export const CHECKOUT_SESSION_RECEIVED_ZUORA = 'CHECKOUT_SESSION_RECEIVED_ZUORA'
export const CHECKOUT_SESSION_RECEIVED_STRIPE =
  'CHECKOUT_SESSION_RECEIVED_STRIPE'
export const GENERATE_PAYMENT_PAGE_DATA_REQUESTED =
  'GENERATE_PAYMENT_PAGE_DATA_REQUESTED'
export const GENERATE_PAYMENT_PAGE_DATA_RECEIVED =
  'GENERATE_PAYMENT_PAGE_DATA_RECEIVED'
export const ADD_PAYMENT_METHOD_SUCCEED = 'ADD_PAYMENT_METHOD_SUCCEED'
export const PAYMENT_SUCCESS = 'PAYMENT_SUCCESS'
export const SUBSCRIPTION_PLANS_REQUESTED = 'SUBSCRIPTION_PLANS_REQUESTED'
export const SUBSCRIPTION_PLANS_RECEIVED = 'SUBSCRIPTION_PLANS_RECEIVED'
export const COUPON_REDEEMED = 'COUPON_REDEEMED'
export const CREDIT_REDEEMED = 'CREDIT_REDEEMED'
export const SLOT_EXPIRED = 'SLOT_EXPIRED'
export const SLOT_EXPIRED_POPUP_SHOWED = 'SLOT_EXPIRED_POPUP_SHOWED'
export const SLOT_CLEARED = 'SLOT_CLEARED'
export const ACTIVATE_SLOT_TIMER = 'ACTIVATE_SLOT_TIMER'
export const HIDE_SLOT_TIMER = 'HIDE_SLOT_TIMER'
export const SHOW_SLOT_TIMER = 'SHOW_SLOT_TIMER'
export const CUSTOMER_INSERTED_COUPON = 'CUSTOMER_INSERTED_COUPON'
export const BILLING_PORTAL_REQUESTED = 'BILLING_PORTAL_REQUESTED'
export const BILLING_PORTAL_RECEIVED = 'BILLING_PORTAL_RECEIVED'
export const CHANGE_PAYMENT_METHOD = 'CHANGE_PAYMENT_METHOD'
export const ADD_PAYMENT_METHOD = 'ADD_PAYMENT_METHOD'
export const PAYMENT_METHOD_UPDATED = 'PAYMENT_METHOD_UPDATED'
export const ANALYTICS_COUPON_NOT_VALID = 'ANALYTICS_COUPON_NOT_VALID'
export const INVALD_COUPON_RECIEVED = 'INVALD_COUPON_RECIEVED'
export const PAYMENT_FLOW_COMPLETED = 'PAYMENT_FLOW_COMPLETED'
export const PAYMENT_FLOW_CANCELLED = 'PAYMENT_FLOW_CANCELLED'
export const PAYMENT_FLOW_TRIGGERED = 'PAYMENT_FLOW_TRIGGERED'
export const HOLDAY_IS_HERE_BABY = 'HOLDAY_IS_HERE_BABY'
export const UPLOAD_INVOICE_COMPONENT_REQUESTED =
  'UPLOAD_INVOICE_COMPONENT_REQUESTED'
export const UPLOAD_INVOICE_COMPONENT_RECEIVED =
  'UPLOAD_INVOICE_COMPONENT_RECEIVED'
export const UPLOAD_INVOICE_FLOW_COMPLETE = 'UPLOAD_INVOICE_FLOW_COMPLETE'
export const SUBSCRIPTION_PLANS_ZOURA_RECEIVED =
  'SUBSCRIPTION_PLANS_ZOURA_RECEIVED'
export const PROCEED_TO_CHECKOUT_PRESSED = 'PROCEED_TO_CHECKOUT_PRESSED'
export const REDIRECTED_TO_CHECKOUT_PAGE = 'REDIRECTED_TO_CHECKOUT_PAGE'
export const PAYMENT_DETAILS_PRESSED = 'PAYMENT_DETAILS_PRESSED'
export const PLANS_PRESSED = 'PLANS_PRESSED'
export const VIEW_VCC_CLICKED = 'VIEW_VCC_CLICKED'
export const VCC_RECEIVED = 'VCC_RECEIVED'
export const REMOVE_COUPON_CODE = 'REMOVE_COUPON_CODE'
export const REDIRECT_TO_PAYMENT_SUCCESS = 'REDIRECT_TO_PAYMENT_SUCCESS'
export const REDIRECT_TO_PAYMENT_CANCEL = 'REDIRECT_TO_PAYMENT_CANCEL'
export const REDIRECT_TO_ACCOUNTS_PAGE = 'REDIRECT_TO_ACCOUNTS_PAGE'
export const IS_COUPON_SKIP_STRIPE_ADDRESS_UPDATE_REQUESTED =
  'IS_COUPON_SKIP_STRIPE_ADDRESS_UPDATE_REQUESTED'
export const IS_COUPON_SKIP_STRIPE_ADDRESS_UPDATE_RECEIVED =
  'IS_COUPON_SKIP_STRIPE_ADDRESS_UPDATE_RECEIVED'
export const IS_COUPON_SKIP_STRIPE_ADDRESS_UPDATE_FAILED =
  'IS_COUPON_SKIP_STRIPE_ADDRESS_UPDATE_FAILED'
export const COUPON_DIALOGUE_CANCEL_BUTTON_PRESSED =
  'COUPON_DIALOGUE_CANCEL_BUTTON_PRESSED'
export const PAYMENT_PLAN_REQUESTED = 'PAYMENT_PLAN_REQUESTED'
export const CREATE_ORDER_REQUESTED = 'CREATE_ORDER_REQUESTED'
export const CREATE_ORDER_RECEIVED = 'CREATE_ORDER_RECEIVED'
//WALNUT
export const CHECKOUT_WALNUT_NO_MEMBER_REQUESTED =
  'CHECKOUT_WALNUT_NO_MEMBER_REQUESTED'
export const CHECKOUT_WALNUT_RECEIVED = 'CHECKOUT_WALNUT_RECEIVED'
export const CHECK_USER_EXIST = 'CHECK_USER_EXIST'
export const REQUEST_NON_SUPPORTED_STATE = 'REQUEST_NON_SUPPORTED_STATE'
export const NON_SUPPORTED_STATE_SENDED = 'NON_SUPPORTED_STATE_SENDED'
export const REQUEST_MEDICARE_DIALOG = 'REQUEST_MEDICARE_DIALOG'
export const REQUEST_CLOSE_MEDICARE_DIALOG = 'REQUEST_CLOSE_MEDICARE_DIALOG'
export const SHOW_HTN_PLANS_ONLY = 'SHOW_HTN_PLANS_ONLY'
export const HTN_FOLLOW_UP_BOT_PAYMENT_SUCCESS =
  'HTN_FOLLOW_UP_BOT_PAYMENT_SUCCESS'
export const HTN_FOLLOW_UP_CANCELLED_PAYMENT_FAILED =
  'HTN_FOLLOW_UP_CANCELLED_PAYMENT_FAILED'
export const REQUEST_CANCEL_PENDING_HTNFU_APPOINTMENT =
  'REQUEST_CANCEL_PENDING_HTNFU_APPOINTMENT'
export const CHECK_PPF_PLAN_EMAIL_AND_PHONE_REQUESTED =
  'CHECK_PPF_PLAN_EMAIL_AND_PHONE_REQUESTED'
export const PPF_PLAN_PHONE_REQUESTED = 'PPF_PLAN_PHONE_REQUESTED'
export const CHECK_PPF_PLAN_EMAIL_AND_PHONE_RECEIVED =
  'CHECK_PPF_PLAN_EMAIL_AND_PHONE_RECEIVED'
export const PPF_PLAN_PHONE_RECEIVED = 'PPF_PLAN_PHONE_RECEIVED'
export const PPF_PLAN_PHONE_ISVALID = 'PPF_PLAN_PHONE_ISVALID'
export const PPF_PLAN_PHONE_ISINVALID = 'PPF_PLAN_PHONE_ISINVALID'
export const PPF_PLAN_PHONE_VERIFY = 'PPF_PLAN_PHONE_VERIFY'
export const CHECKOUT_SESSION_NO_MEMBER_REQUESTED_PPF =
  'CHECKOUT_SESSION_NO_MEMBER_REQUESTED_PPF'
export const CLOSE_EMAIL_EXIST_MODAL = 'CLOSE_EMAIL_EXIST_MODAL'
export const CHECK_PPF_PLAN_EMAIL_AND_PHONE_FAILED =
  'CHECK_PPF_PLAN_EMAIL_AND_PHONE_FAILED'
export const PPF_PLAN_PHONE_RECEIVED_FAIL = 'PPF_PLAN_PHONE_RECEIVED_FAIL'
export const NEW_USER_PPF_TOGGLE_MODAL = 'NEW_USER_PPF_TOGGLE_MODAL'
export const CLOSE_NEW_USER_PPF_TOGGLE_MODAL = 'CLOSE_NEW_USER_PPF_TOGGLE_MODAL'
export const PAYMENT_ADDRESS_UPDATED = 'PAYMENT_ADDRESS_UPDATED'
export const UNABLE_TO_PROCESS_ZOURA_PAYMENT = 'UNABLE_TO_PROCESS_ZOURA_PAYMENT'
export const CLOSE_UNABLE_TO_PROCESS_ZOURA_PAYMENT =
  'CLOSE_UNABLE_TO_PROCESS_ZOURA_PAYMENT'
export const ENABLE_ZOURA_PAGE_LOADER = 'ENABLE_ZOURA_PAGE_LOADER'
export const DISABLE_ZOURA_PAGE_LOADER = 'DISABLE_ZOURA_PAGE_LOADER'
export const CLEAR_ZOURA_SIGNATURES = 'CLEAR_ZOURA_SIGNATURES'
export const IS_COUPON_VALID_RECEIVED_SKIP_CHECKOUT_PAGE =
  'IS_COUPON_VALID_RECEIVED_SKIP_CHECKOUT_PAGE'
export const IS_COUPON_SKIP_CHECKOUT_ADDRESS_UPDATE_REQUESTED =
  'IS_COUPON_SKIP_CHECKOUT_ADDRESS_UPDATE_REQUESTED'
export const IS_COUPON_SKIP_CHECKOUT_ADDRESS_UPDATE_RECEIVED =
  'IS_COUPON_SKIP_CHECKOUT_ADDRESS_UPDATE_RECEIVED'
export const COUPON_DIALOG_OPEN = 'COUPON_DIALOG_OPEN'
export const COUPON_DIALOG_CLOSE = 'COUPON_DIALOG_CLOSE'
export const RESET_COUPON_ZUORA = 'RESET_COUPON_ZUORA'
export const PAYMENT_METHOD_DATA_RECIEVED = 'PAYMENT_METHOD_DATA_RECIEVED'
export const PAYMENT_METHOD_DATA_REQUESTED = 'PAYMENT_METHOD_DATA_REQUESTED'
export const PAYMENT_METHOD_FETCH_FAILED = 'PAYMENT_METHOD_FETCH_FAILED'
export const BALANCE_PER_SUBSCRIPTION_RECIEVED =
  'BALANCE_PER_SUBSCRIPTION_RECIEVED'
export const GENERATE_UPDATE_PAYMENT_CARD_REQUESTED =
  'GENERATE_UPDATE_PAYMENT_CARD_REQUESTED'
export const GENERATE_UPDATE_PAYMENT_CARD_RECEIVED =
  'GENERATE_UPDATE_PAYMENT_CARD_RECEIVED'

export const PAYMENT_METHOD_CARD_UPDATE_REQUESTED =
  'PAYMENT_METHOD_CARD_UPDATE_REQUESTED'
export const PAYMENT_METHOD_CARD_UPDATED = 'PAYMENT_METHOD_CARD_UPDATED'
export const PAYMENT_METHOD_CARD_FAILED = 'PAYMENT_METHOD_CARD_FAILED'

export const SHOW_NO_SUBSCRIPTIONS_MODAL = 'SHOW_NO_SUBSCRIPTIONS_MODAL'
export const CLOSE_NO_SUBSCRIPTIONS_MODAL = 'CLOSE_NO_SUBSCRIPTIONS_MODAL'
export const INVOKE_PPF_ORDER = 'INVOKE_PPF_ORDER'
export const REVOKE_PPF_ORDER = 'REVOKE_PPF_ORDER'
export const KEEP_PPF_USER_INFO = 'KEEP_PPF_USER_INFO'
export const DISCARD_PPF_USER_INFO = 'DISCARD_PPF_USER_INFO'
export const CREATE_ORDER_REQUESTED_PPF = 'CREATE_ORDER_REQUESTED_PPF'
export const PAYMENT_SUCCESS_FROM_PPF = 'PAYMENT_SUCCESS_FROM_PPF'
export const ENABLE_NO_SERVICE_DIALOG = 'ENABLE_NO_SERVICE_DIALOG'
export const DISBALE_NO_SERVICE_DIALOG = 'DISBALE_NO_SERVICE_DIALOG'
export const ENABLE_SOMETHING_WENT_WRONG_DIALOG =
  'ENABLE_SOMETHING_WENT_WRONG_DIALOG'
export const DISABLE_SOMETHING_WENT_WRONG_DIALOG =
  'DISABLE_SOMETHING_WENT_WRONG_DIALOG'
export const CHECKOUT_SESSION_WITHOUT_PAYMENT_REQUESTED =
  'CHECKOUT_SESSION_WITHOUT_PAYMENT_REQUESTED'
export const CHECKOUT_SESSION_WITHOUT_PAYMENT_RECEIVED =
  'CHECKOUT_SESSION_WITHOUT_PAYMENT_RECEIVED'
export const CHECKOUT_SESSION_WITHOUT_PAYMENT_FAILURE =
  'CHECKOUT_SESSION_WITHOUT_PAYMENT_FAILURE'
export const CHECK_EXISTING_PPF_USER_SUBSCRIPTIONS_REQUESTED =
  'CHECK_EXISTING_PPF_USER_SUBSCRIPTIONS_REQUESTED'
export const CHECK_EXISTING_PPF_USER_SUBSCRIPTIONS_RECIEVED =
  'CHECK_EXISTING_PPF_USER_SUBSCRIPTIONS_RECIEVED'
export const CHECK_EXISTING_PPF_USER_SUBSCRIPTIONS_FAILED =
  'CHECK_EXISTING_PPF_USER_SUBSCRIPTIONS_FAILED'
export const PAYMENT_SUCCESS_ALERT_ACKNOWLEDGED =
  'PAYMENT_SUCCESS_ALERT_ACKNOWLEDGED'

export const ENABLE_FROM_PAYMENT_PLANS = 'ENABLE_FROM_PAYMENT_PLANS'
export const DISABLE_FROM_PLANS_PAGE = 'DISABLE_FROM_PLANS_PAGE'
export const COPAY_PLAN_DETAILS_REQUESTED = 'COPAY_PLAN_DETAILS_REQUESTED'
export const COPAY_PLAN_DETAILS_RECEIVED = 'COPAY_PLAN_DETAILS_RECEIVED'

export const CLOSE_APPROVE_PAYMENT_POP_UP = 'CLOSE_APPROVE_PAYMENT_POP_UP'
export const SHOW_APPROVE_PAYMENT_POP_UP = 'SHOW_APPROVE_PAYMENT_POP_UP'

export const ENABLE_SLOT_EXPIRE_DIALOG = 'ENABLE_SLOT_EXPIRE_DIALOG'
export const DISBALE_SLOT_EXPIRE_DIALOG = 'DISBALE_SLOT_EXPIRE_DIALOG'

export const PAYMENT_INVOICE_REQUESTED = 'PAYMENT_INVOICE_REQUESTED'
export const PAYMENT_INVOICE_RECEIVED = 'PAYMENT_INVOICE_RECEIVED'
export const PAYMENT_INVOICE_FAILED = 'PAYMENT_INVOICE_FAILED'

export const UNAUTENTICATED_PAYMENT_DETAILS_REQUESTED =
  'UNAUTENTICATED_PAYMENT_DETAILS_REQUESTED'
export const UNAUTENTICATED_PAYMENT_DETAILS_RECEIVED =
  'UNAUTENTICATED_PAYMENT_DETAILS_RECEIVED'
export const UNAUTENTICATED_PAYMENT_DETAILS_FAILED =
  'UNAUTENTICATED_PAYMENT_DETAILS_FAILED'

export const DISPLAY_AUTO_PAY_POPUP = 'DISPLAY_AUTO_PAY_POPUP'
export const CLOSE_AUTO_PAY_POPUP = 'CLOSE_AUTO_PAY_POPUP'

export const SET_AUTO_PAY_REQUESTED = 'SET_AUTO_PAY_REQUESTED'
export const SET_AUTO_PAY_RECEIVED = 'SET_AUTO_PAY_RECEIVED'
export const SET_AUTO_PAY_FAILED = 'SET_AUTO_PAY_FAILED'

export const CONFIRM_AUTO_PAY_CLICKED = 'CONFIRM_AUTO_PAY_CLICKED'

export const UPDATE_INCLUDE_DUE_STATUS = 'UPDATE_INCLUDE_DUE_STATUS'
export const UPDATE_PAYMENT_CONFIG_SUBSCRIPTION =
  'UPDATE_PAYMENT_CONFIG_SUBSCRIPTION'
export const UPDATE_TOTAL_PAYMENT_PRICE = 'UPDATE_TOTAL_PAYMENT_PRICE'

export const SELECT_ENROLLMENT_YEAR_VIEW = 'SELECT_ENROLLMENT_YEAR_VIEW'
